import Swal from "sweetalert2";
import {
  ADDCOURSE,
  ADDFRANCHISEIMG,
  ADDFRANCHISES,
  ADDFRANCHISESREQUIRENMENT,
  ADDFRANCHISESSUPPORT,
  ADDINSTITUTE,
  GETCOURSES,
  GETCOURSESENQUIRIES,
  GETFRANCHISEENQUIRIES,
  GETFRANCHISEIMG,
  GETFRANCHISES,
  GETFRANCHISESREQUIRENMENT,
  GETFRANCHISESSUPPORT,
  GETINSTITUTE,
  UPDATECOURSE,
  UPDATEFRANCHISEIMG,
  UPDATEFRANCHISES,
  UPDATEFRANCHISESREQUIRENMENT,
  UPDATEFRANCHISESSUPPORT,
  UPDATEINSTITUTE,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";




export const getFranchise = async (payload, callback) => {
  await axios
    .post(GETFRANCHISES, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const franchiseUpdate = async (payload, callback) => {
  await axios
    .post(UPDATEFRANCHISES, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const franchiseAdd = async (payload, callback) => {
  await axios
    .post(ADDFRANCHISES, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const franchiseRequirenmentAdd = async (payload, callback) => {
  await axios
    .post(ADDFRANCHISESREQUIRENMENT, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFranchiseRequirenment = async (payload, callback) => {
  await axios
    .post(GETFRANCHISESREQUIRENMENT, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};
export const franchiseRequirenmentUpdate = async (payload, callback) => {
  await axios
    .post(UPDATEFRANCHISESREQUIRENMENT, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFranchiseSupport = async (payload, callback) => {
  await axios
    .post(GETFRANCHISESSUPPORT, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const franchiseSupporttAdd = async (payload, callback) => {
  await axios
    .post(ADDFRANCHISESSUPPORT, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const franchiseSupportUpdate = async (payload, callback) => {
  await axios
    .post(UPDATEFRANCHISESSUPPORT, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getFranchiseImg = async (payload, callback) => {
  await axios
    .post(GETFRANCHISEIMG, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const franchiseAddAdd = async (payload, callback) => {
  await axios
    .post(ADDFRANCHISEIMG, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const franchiseImgUpdate = async (payload, callback) => {
  await axios
    .post(UPDATEFRANCHISEIMG, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllEnquiriesById = async (payload, callback) => {
  await axios
    .post(GETFRANCHISEENQUIRIES, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};